<ion-header>
  <app-search-input [debounce]="300" (backEvent)="backToCategories()" [searchText]="searchText()" [back]="state() === 'search'" (searchClear)="searchCleared()" (searchChanged)="searchChange($event)" (focused)="searchFocus()" (focusedout)="searchFocusOut()"/>
</ion-header>

<ion-content>
  <div class="categories" [class.search-container]="state() === 'search'">
    @switch (state()) {
      @case ('top') {
        <app-category-grid title="Top categories">
          @for (category of categories(); track $index) {
            <app-category-card (select)="goToCategory($event,'category')" [data]="category" type="category" />
          }
        </app-category-grid>
        <app-category-grid title="All categories">
          @for (category of subCategories(); track $index) {
            <app-category-card (select)="goToCategory($event, 'subcategory')" [data]="category" type="subcategory" />
          }
        </app-category-grid>
      }
      @case ('search') {
        @if (recentSearchTerms.length) {
          <app-item-search  (searchSelect)="selectedSearchElement($event)" type="recent"/>
        }
        <app-item-search (searchSelect)="selectedSearchElement($event)" type="popular" />
      }
    }
    <app-product-scroller [class.visible]="state()==='grid'" [searchText]="searchText()" [limit]="10" />
  </div>
</ion-content>
